import { render, staticRenderFns } from "./form-bill.vue?vue&type=template&id=4ef1e848&scoped=true&"
import script from "./form-bill.vue?vue&type=script&lang=js&"
export * from "./form-bill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef1e848",
  null
  
)

export default component.exports